module.exports = __webpack_public_path__ + "static/media/dashboard.bfca41a2.svg";